module.exports = __webpack_public_path__ + "static/media/loop.683be39f.mp4";